import { useState } from 'react';

import InternalErrorState, { errorConfig, PageError } from '@/features/app/InternalErrorState';
import MaintenanceHistoryTable from '@/features/history/MaintenanceHistoryTable';
import LifetimeStatus from './lifetime_status/LifetimeStatus';

const MaintenancePage = () => {
    const [pageError, setPageError] = useState<PageError | undefined>(undefined);

    if (pageError) {
        const { headlineI18n, messageI18n } = errorConfig[pageError];
        return <InternalErrorState headlineI18n={headlineI18n} messageI18n={messageI18n} />;
    }

    return (
        <>
            <LifetimeStatus setPageError={setPageError} />
            <MaintenanceHistoryTable />
        </>
    );
};

export default MaintenancePage;
